import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  useToast,
} from "@chakra-ui/react"
import React from "react"
import { api } from "../../../../services/api"

export function ConfirmDialog({ item, resultado }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const [loading, setLoading] = React.useState(false)

  const toast = useToast({
    position: "top",
    duration: 3000,
    isClosable: true,
  })

  async function updateUsu() {
    try {
      setLoading(true)
      const params = {
        numero_pedido: item.numero_pedido,
      }

      const response = await api.post("/site/v2/categoria/solicita-conferencia-contabilidade", params)

      console.log("response: ", response)

      onClose()
      resultado({ codParc: "", pedido: "", dataDe: "", dataAte: "", pendente: "", nfe: "" })
      setLoading(false)
      toast({
        title: "Sucesso!",
        description: "Pedido enviado para contabilidade com sucesso!",
        status: "success",
        duration: 9000,
        isClosable: true,
      })
    } catch (error) {
      console.log("error: ", error)
      toast({
        title: "Erro!",
        description: "Erro ao enviar pedido para contabilidade!",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue" size="sm">
        Enviar para contabilidade
      </Button>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Tem certeza?</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            Você está prestes a enviar o pedido <strong>{item.numero_pedido}</strong>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={() => updateUsu()} colorScheme="blue" isLoading={loading} loadingText="Enviando">
              Sim
            </Button>
            <Button colorScheme="red" ref={cancelRef} onClick={onClose} ml={3}>
              Não
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
